<!--
 * @Author: lsq
 * @Date: 2024-10-08 18:11:41
 * @LastEditTime: 2025-09-08 16:43:09
 * @LastEditors: lsq
 * @Description: 
 * @FilePath: /sunpay-web/src/components/layout/VisitedViews.vue
-->
<template>
  <div class="views-box">
    <div class="views-list">
      <div v-for="(item, index) in views" :key="viewKey(item)" @click="goto(item)" :class="['view-item', isActive(item) ? 'view-item-active' : '']">
        {{ item.name }}
        <template v-if="item.query && item.label">{{ item.query[item.label] }}</template>
        <el-icon v-if="views.length > 1" @click.stop="removeViews(item, index)"><Close />
      </el-icon>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Close } from '@element-plus/icons-vue';
import { computed, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
const $store = inject('$store')
const router = useRouter()
const route = useRoute()
const views = computed(() => $store?.state?.visitedMenu || [])
const viewKey = (item) => {
  if (item?.query && item?.label) {
    return `${item.path}?${item.label}=${item.query[item.label]}`
  }
  return item.path
}
const isActive = (item) => {
  if (route.path !== item.path) return false
  if (item?.query && item?.label) {
    return route.query?.[item.label] == item.query?.[item.label]
  }
  return true
}
const goto = (item) => {
  if (item.query) {
    router.push({
      path: item.path,
      query: item.query
    })
  } else {
    router.push({
      path: item.path
    })
  }
}

const removeViews = (item, index) => {
  const fullPath = router.resolve({ path: item.path, query: item.query }).fullPath
  $store.commit("BUMP_VIEW_CACHE_VERSION", fullPath)
  if (isActive(item)) {
    const list = views.value || []
    const fallback = index > 0 ? list[index - 1] : list[index + 1]
    if (fallback?.query) {
      router.push({
        path: fallback.path,
        query: fallback.query
      })
    } else if (fallback?.path) {
      router.push({
        path: fallback.path,
      })
    } else {
      const first = $store.state.firstMenuPath
      router.push({ path: first?.path || '/dashboard' })
    }
  }
  $store.commit("DEL_VISITEDMENU", item);
}
</script>
<style lang="less" scoped>
  .views-box {
    flex: 1;
    min-width: 0;
    height: 44px;
    .views-list {
      height: 44px;
      line-height: 34px;
      margin-top: 6px;
      display: flex;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-gutter: stable;
      max-width: 100%;
    }
    .view-item {
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      padding: 0 16px;
      white-space: nowrap;
      .el-icon {
        margin-top: 3px;
      }
      &-active {
        background: #fff;
        color: #4096ff;
      }
    }
  }
</style>
